export class FederatedCatalogInfo {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "sourceType",
            "baseName": "sourceType",
            "type": "FederatedSourceType",
            "format": ""
        },
        {
            "name": "sync",
            "baseName": "sync",
            "type": "FederatedSyncState",
            "format": ""
        },
        {
            "name": "connection",
            "baseName": "connection",
            "type": "FederatedConnection",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return FederatedCatalogInfo.attributeTypeMap;
    }
    constructor() {
    }
}
